export const storageAccessToken = 'thea@access_token';
export const storageRefreshToken = 'thea@refresh_token';
export const storageTokenTimeout = 'thea@token_timeout';
